import styled from "styled-components";

export const ActionButtons = styled.div`
  & .Polaris-LegacyStack__Item:not(:first-of-type) {
    margin-left: 6px;
  }
`;
